import { render, staticRenderFns } from "./AdminManageClaimantAddressModal.vue?vue&type=template&id=f756222c"
import script from "./AdminManageClaimantAddressModal.vue?vue&type=script&lang=js"
export * from "./AdminManageClaimantAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports